import Message from 'element-ui/lib/message';
import lrz from 'lrz';
import utils from '../libs/utils';
import Http from '../libs/http';
import { mapiBase } from '../libs/env';

export default {
  // 一般电子资料上传
  doUpload(material, uploadItem, orderId, applicantId, key, download_name) {
    return Http.post('/applicant_elec_upload', {
      user_order_id: orderId,
      order_applicant_id: applicantId,
      elec_id: material.elec_id,
      pos: uploadItem.pos,
      key,
      download_name,
    }).then((data) => {
      uploadItem.url = data.url;
      delete uploadItem.file;
      utils.msg.success('上传成功');
    }).catch((e) => {
      if (e) console.log(e);
    }).finally(() => {
      uploadItem.loading = false;
    });
  },

  // 获取data上传阿里云
  uploadFile(file, zipImg, opts) {
    return new Promise((resolve, reject) => {
      Http.post('/sys/upload_file_request', {
        filename: file.name,
      }).then((data) => {
        this.uploadAliyun(data, file, zipImg, opts).then((res) => {
          resolve(res.key);
        }).catch((err) => {
          reject(err);
        });
      }).catch((err) => {
        reject(err);
      });
    });
  },

  uploadFileWithOssout(file, zipImg, opts) {
    return new Promise((resolve, reject) => {
      Http.post('/sys/upload_file_request', {
        filename: file.name || (`${new Date().getTime()}.png`),
      }).then((data) => {
        this.uploadAliyun(data, file, zipImg, opts).then((res) => {
          resolve({
            oss_out: data.oss_out,
            key: res.key,
          });
        }).catch((err) => {
          reject(err);
        });
      }).catch((err) => {
        reject(err);
      });
    });
  },

  // 上传阿里云
  uploadAliyun(data, file, zipImg, opts) {
    function doUpload(f, resolve, reject) {
      const formData = new FormData();
      formData.append('OSSAccessKeyId', data.access_key);
      if (opts && opts.noKey) {
        formData.append('key', data.key);
        formData.append('success_action_status', 200);
      } else {
        formData.append('key', data.key);
      }
      formData.append('policy', data.policy);
      formData.append('Signature', data.signature);
      if (data.callback) {
        formData.append('callback', data.callback);
      }
      if (data.my_val) {
        Object.keys(data.my_val).forEach((k) => {
          formData.append(k, data.my_val[k]);
        });
      }
      formData.append('file', f);
      const xhr = new XMLHttpRequest();
      xhr.open('post', `//${data.oss_out}`);
      xhr.onload = function () {
        if (xhr.responseText.indexOf('<Error>') > -1) {
          reject(xhr.responseText);
          Message.error('上传文件参数错误');
          return;
        }
        if (xhr.response) {
          const resJson = JSON.parse(xhr.response);
          if (resJson.ret === 0) {
            resolve(resJson.body);
          } else {
            reject(resJson.msg);
            opts.noToast || Message.error(resJson.msg);
          }
        } else {
          if (xhr.status === 200) {
            resolve({ key: data.key });
          } else {
            reject('上传文件失败');
          }
        }
      };
      xhr.onerror = function () {
        reject('上传文件失败');
        Message.error('上传文件失败!');
      };
      xhr.send(formData);
    }
    return new Promise(((resolve, reject) => {
      if (zipImg) {
        lrz(file, { width: 1200, quality: 0.8 }).then((rst) => {
          doUpload(rst.file, resolve, reject);
        }).catch(() => {
          Message.error('图片处理失败');
          reject('');
        });
      } else {
        doUpload(file, resolve, reject);
      }
    }));
  },

  /**
   * 上传证件照
   * @param {Number} user_order_id 订单号
   * @param {Number} order_applicant_id 申请人号
   */
  uploadIdPhoto(user_order_id, order_applicant_id, need_check, key, clear_memo) {
    return Http.post('/applicant_id_photo_upload', {
      user_order_id,
      order_applicant_id,
      need_check,
      key,
      clear_memo,
      need_handle: 1,
    }, { noToast: true });
  },

  /**
   * 电子资料特殊处理
   * @param {Number} elec_id 电子资料编号
   * @param {Number} order_applicant_id 申请人编号
   * @param {Number} user_order_id 订单号
   * @param {Number} special_code 特殊状态码
   */
  elecSpecialHandle(elec_id, order_applicant_id, user_order_id, special_code) {
    return Http.post('/applicant_elec_special_handle', {
      elec_id,
      order_applicant_id,
      user_order_id,
      special_code,
    });
  },

  /**
   * 按换行符分割字符串，返回一个字符串数组
   * @param {String} attention
   * @return {Array}
   */
  makeStringList(attention) {
    if (!attention) return [];
    if (Array.isArray(attention)) return attention;
    const attentionList = [];
    return attentionList.concat(attention.indexOf('\n') === -1 ? attention : attention.split('\n'));
  },

  // 为ocr上传图片的接口
  upload4Ocr(url, file, zipImg, options) {
    const me = this;
    options = options || {};
    function doUpload(f, resolve, reject) {
      const formData = new FormData();
      formData.append('file', f);

      const xhr = new XMLHttpRequest();
      xhr.open('post', `${mapiBase}${url}`);


      const header = Http.getHttpAuthHeader({ type: 'vms' });
      Object.keys(header).forEach((k) => {
        xhr.setRequestHeader(k, header[k]);
      });

      xhr.onload = function (e) {

        if (e.target.status !== 200) {
          options.noToast || Message.error('请求错误，请重新上传');
          return reject('');
        }

        if (xhr.responseText.indexOf('<Error>') > -1) {
          reject(xhr.responseText);
          options.noToast || Message.error('上传文件参数错误');
          return;
        }

        const resJson = JSON.parse(xhr.response);
        if (resJson.ret === 0) {
          // 处理日期的合法
          const data = me.handlePassportAndIdcardDateInvalid(resJson.body);
          resolve(data);
        } else {
          reject(resJson.msg);
          options.noToast || Message.error(resJson.msg);
        }
      };
      xhr.onerror = function () {
        reject('上传失败，请重试');
        options.noToast || Message.error('上传失败，请重试!');
      };
      xhr.send(formData);
    }

    return new Promise(((resolve, reject) => {
      if (zipImg) {
        lrz(file, { width: 1200, quality: 0.8 }).then((rst) => {
          doUpload(rst.file, resolve, reject);
        }).catch((e) => {

          if ('fundebug' in window) {
            window.fundebug.notifyError('护照图片处理失败原因', e);
          }

          Message.error('图片处理失败');
          reject('');
        });
      } else {
        doUpload(file, resolve, reject);
      }
    }));
  },

  // 上传ocr资料
  uploadOcrMaterial(file, type, options) {
    options = options || {};
    const url = type === 'passport' ? '/ocr/passport_recognize' : '/ocr/id_card_recognize';

    return this.upload4Ocr(url, file, options.zipImg, options);
  },

  // 处理护照日期不合法
  handlePassportAndIdcardDateInvalid(passport) {
    const dateField = ['birthday', 'expire_date', 'issue_date'];
    dateField.forEach((field) => {
      if (passport[field] && !utils.isValidDate(passport[field])) {
        passport[field] = '';
      }
    });
    return passport;
  },
  

};



// WEBPACK FOOTER //
// ./src/services/upload-file-service.js